// extracted by mini-css-extract-plugin
export default {"ButtonLight":"ButtonBlue_ButtonLight__L9Lws"};